import { render, staticRenderFns } from "./assignFixedNonCTCcomponents.vue?vue&type=template&id=72928063&scoped=true"
import script from "./assignFixedNonCTCcomponents.vue?vue&type=script&lang=js"
export * from "./assignFixedNonCTCcomponents.vue?vue&type=script&lang=js"
import style0 from "./assignFixedNonCTCcomponents.vue?vue&type=style&index=0&id=72928063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72928063",
  null
  
)

export default component.exports